import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class GambleControl extends AbstractControl {
    private gambleBtn: FlexiButton;
    private collectBtn: FlexiButton;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        if (assetNames.length > 0) {
            this.gambleBtn = layer.getFlexiButton(assetNames[0]);
        }

        if (assetNames.length > 1) {
            this.collectBtn = layer.getFlexiButton(assetNames[1]);
        }
    }

    public setEnabled(enabled: boolean): void {
        super.setEnabled(enabled);
        this.gambleBtn.setEnabled(enabled);
        this.collectBtn.setEnabled(enabled);
    }
}
